import { Component, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenericStudentCardComponent } from '../generic-student-card/generic-student-card.component';
import { CertificationActionsComponent } from '../student-card-actions/certification-actions/certification-actions.component';
import { AdminActionsComponent } from '../student-card-actions/admin-actions/admin-actions.component';
import { SchoolRosterStudent } from '@k12/models';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'lib-student-card',
  template: `
    <lib-generic-student-card
      #card
      [editable]="editable"
      [student]="student"
      [schoolTermGrades]="schoolTermGrades"
      [schoolGradeYears]="schoolGradeYears"
      [attendanceTypes]="attendanceTypes"
      [isExpanded]="isExpanded"
      [lockPriorTermCosts]="false"
      [onActionCompleted]="onActionCompleted"
      (toggleExpand)="toggleExpand.emit($event)">
      @if (editable) {
        <lib-certification-actions
          studentCardActions
          [student]="student"
          [schoolCertificationRestricted]="issueRestrictions?.certificationRestricted ?? null"
          [form]="card.form"
          [isNotAttending]="card.isNotAttending"
          [individualCostErrors]="card.individualCostErrors"
          (certified)="onCertified($event)"
          (validateForm)="card.validateIndividualCost()"
          (syncFormToModel)="card.syncFormToModel()"
          (cancelForm)="card.resetForm()">
        </lib-certification-actions>
      }
      @if (showAdminActions) {
        <lib-admin-actions
          studentCardActions
          [student]="student"
          [form]="card.form"
          [isNotAttending]="card.isNotAttending"
          [individualCostErrors]="card.individualCostErrors"
          (saved)="onSaved($event)"
          (reverted)="onReverted($event)"
          (validateForm)="card.validateIndividualCost()"
          (syncFormToModel)="card.syncFormToModel()">
        </lib-admin-actions>
      }
    </lib-generic-student-card>
  `,
  standalone: true,
  imports: [GenericStudentCardComponent, CertificationActionsComponent, AdminActionsComponent]
})
export class StudentCardComponent extends GenericStudentCardComponent {
  @Input() override editable = false;
  @Input() override isExpanded = false;
  @Input() showAdminActions = false;
  @Input() onSavedCallback?: (studentEnrollmentId: string) => void;
  @Input() onRevertedCallback?: (studentEnrollmentId: string) => void;
  @Input() onWithdrawalCallback?: (student: SchoolRosterStudent) => void;
  @Output() certified = new EventEmitter<string>();
  @Output() saved = new EventEmitter<string>();
  @Output() reverted = new EventEmitter<string>();

  constructor() {
    super();
  }

  onCertified(studentEnrollmentId: string): void {
    this.certified.emit(studentEnrollmentId);
    if (this.onCertifiedCallback) {
      this.onCertifiedCallback(studentEnrollmentId);
    }
    if (this.onActionCompleted) {
      this.onActionCompleted(studentEnrollmentId);
    }
  }

  onSaved(studentEnrollmentId: string): void {
    this.saved.emit(studentEnrollmentId);
    if (this.onSavedCallback) {
      this.onSavedCallback(studentEnrollmentId);
    }
  }

  onReverted(studentEnrollmentId: string): void {
    this.reverted.emit(studentEnrollmentId);
    if (this.onRevertedCallback) {
      this.onRevertedCallback(studentEnrollmentId);
    }
    if (this.onActionCompleted) {
      this.onActionCompleted(studentEnrollmentId);
    }
  }
}
